/** The key dialog (BENCH-UX-SPEC §1, SD-2, SD-3): entry, "Remember key", "Forget key". */
import { useState } from 'preact/hooks';
import { KEY } from '../strings-bench.ts';
import { Dialog } from '../ui.tsx';
import { forgetKeyAction, keySubmitted, saveKey } from './controller.ts';
import { apiKey, keyDialogOpen, keyRemembered } from './state.ts';

export function KeyDialog() {
	const [value, setValue] = useState('');
	const [remember, setRemember] = useState(keyRemembered.value);
	const [error, setError] = useState<string | null>(null);
	const open = keyDialogOpen.value;
	const close = () => {
		keyDialogOpen.value = false;
	};
	const submit = (e: Event) => {
		e.preventDefault();
		const v = value.trim();
		if (!v) {
			setError(KEY.empty);
			return;
		}
		setError(null);
		saveKey(v, remember);
		setValue('');
		keySubmitted();
	};
	return (
		<Dialog
			title={KEY.dialogTitle}
			open={open}
			onClose={close}
			actions={
				<>
					<button type="button" class="btn btn-secondary" onClick={close}>
						{KEY.cancel}
					</button>
					{apiKey.value ? (
						<button
							type="button"
							class="btn btn-secondary"
							onClick={() => {
								forgetKeyAction();
								setValue('');
							}}
						>
							{KEY.forget}
						</button>
					) : null}
					<button type="submit" form="bench-key-form" class="btn btn-primary">
						{KEY.save}
					</button>
				</>
			}
		>
			<form id="bench-key-form" onSubmit={submit}>
				<label class="field-label" for="bench-key-input">
					{KEY.label}
				</label>
				<input
					id="bench-key-input"
					class="input"
					type="password"
					autocomplete="off"
					spellcheck={false}
					value={value}
					placeholder="sk-ant-…"
					onInput={(e) => setValue((e.target as HTMLInputElement).value)}
				/>
				<p class="dim">{KEY.hint}</p>
				<label class="check-label">
					<input
						class="check"
						type="checkbox"
						checked={remember}
						onChange={(e) => setRemember((e.target as HTMLInputElement).checked)}
					/>
					<span>{KEY.remember}</span>
				</label>
				{error ? (
					<p class="note-box note-error" role="alert">
						{error}
					</p>
				) : null}
			</form>
		</Dialog>
	);
}
